import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import { getRestaurantData } from "../AddResturant/Resturant.action";
import { addDayOpening } from "./Day.action";
import { setHeading } from "../../../accounts/account.actions";
import Select from 'react-select';
import moment from "moment";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const OpeningDay = (props) => {
    const [cash, setCash] = useState('');
    const [resturant, setResturant] = useState({
        id: '',
        label: ''
    });

    function uploadPurchase() {
        props.addDayOpening({
            cashInHand: cash,
            restaurant: resturant.id
        },
            showSuccessAlert,
            showErrorAlert,
        );
        setCash('');
        setResturant({ id: '', label: '' })
    }

    const restaurantList = !isEmpty(props.restaurantDataList) ? props.restaurantDataList.map((x) => ({ value: x._id, label: x.restaurantName })) : [];

    useEffect(() => {
        props.getRestaurantData();
        props.setHeading("Day Open")
    }, []);

    return (
        <>
            {props.isFetchingRestaurant ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Form>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Date *</b></Form.Label>
                                    <Form.Control
                                        type="date"
                                        placeholder="Date"
                                        name="Date" value={moment().format("YYYY-MM-DD")} disabled={true} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Select Company *</b> </Form.Label>
                                    <Select
                                        placeholder="Select Company"
                                        onChange={(e) => setResturant((prev) => ({ ...prev, id: e.value, label: e.label }))}
                                        options={restaurantList}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Cash *</b></Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Cash"
                                        name="Cash"
                                        value={cash}
                                        onChange={(e) => setCash(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col></Col>
                        </Row>

                        <div className="sendDiv">
                            <Button disabled={cash == "" || resturant.id == '' ? true : false} variant="contained" endIcon={<SendIcon />} size="large" onClick={uploadPurchase} > SAVE </Button>
                        </div>

                    </Form>
                </Container>
            )}
        </>
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        getRestaurantData: () => dispatch(getRestaurantData()),
        addDayOpening: (data, showSuccessAlert, showErrorAlert) => dispatch(addDayOpening(data, showSuccessAlert, showErrorAlert)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isFetchingRestaurant: state.ResturantReducer.isFetchingRestaurant,
    restaurantDataList: state.ResturantReducer.restaurantDataList,
});

export default connect(mapStateToProps, mapDispatchToProps)(OpeningDay);